<script setup lang="ts">
import type { ILazyImageProps } from '~/interfaces/components/lazy-image';
import LazyImage from '~/components/design-system/lazy-image.vue';

const { getRegionImage } = useBranding();

const props = withDefaults(defineProps<Partial<ILazyImageProps>>(), {
  loading: 'eager',
  fetchPriority: 'high',
});

const diamondSvg = computed(() => getRegionImage('diamondPattern'));
</script>
<template>
  <LazyImage
    :src="diamondSvg"
    :show-placeholder="false"
    :class="[props?.class, 'animate-pulse !duration-1000 text-transparent']"
    :fetch-priority="props.fetchPriority"
    :loading="props.loading"
  />
</template>
